export default "__VITE_ASSET__0afb817b__"